import axios from 'axios'
import {UrlService} from "@/services/UrlService";
import {KEYS_MODULE} from "@/services/ConstantService";
import {GlobalService} from "@/services/GlobalService";
export const ModuleService = {
  async getModuleKeys (params) {
    let queryString=UrlService.setQueryString(params)
    return await axios.get(KEYS_MODULE + queryString).then(response => {
      return response.data ?? false
    }).catch(error => {
      GlobalService.handleError(error, 'GET MODULE KEYS SERVICE')
      return false
    })
  },

}

export default { ModuleService }
